import agent_attorney from "./agent_attorney";
import agent_attorney_individs from "./agent_attorney_individs";
import employer from "./employer";
import employer_pocs from "./employer_pocs";
import foreign_labor from "./foreign_labor";
import crop from "./crop";
import agriculture from "./agriculture";
import worker_housing from "./worker_housing";
import material_terms from "./material_terms";
import foreign_worker from "./foreign_worker";
import foreign_worker_group from "./foreign_worker_group";


const DeleteEntityQueryResolver = (tableName, id) => {
  const viewEntityQueryList = {
    "agent-attorney": agent_attorney(id),
    "agent-attorney-individs": agent_attorney_individs(id),
    employer: employer(id),
    "employer-pocs": employer_pocs(id),
    "foreign-labor": foreign_labor(id),
    crop: crop(id),
    "worker-housing": worker_housing(id),
    agriculture: agriculture(id),
    "material-terms": material_terms(id),
    "foreign-worker": foreign_worker(id),
    "foreign-worker-group": foreign_worker_group(id),
  };
  return viewEntityQueryList[tableName];
};

export default DeleteEntityQueryResolver;
